export type HapticStyle = 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error';

// Vibration durations in ms, matched to common haptic feedback patterns.
const PATTERNS: Record<HapticStyle, number | number[]> = {
  light:   10,
  medium:  20,
  heavy:   40,
  success: [8, 60, 8],
  warning: [25, 40, 25],
  error:   [40, 30, 40],
};

export function haptic(style: HapticStyle = 'light'): void {
  if (typeof navigator === 'undefined') return;
  try { navigator.vibrate?.(PATTERNS[style]); } catch (_) { /* vibration not supported */ }
}
